import React from "react";
import { Button } from "react-bootstrap";
import "../../App.css";
import { useAuth0 } from "@auth0/auth0-react";

const ForbiddenPage: React.FC = () => {
  // const navigate = useNavigate()
  const {logout} = useAuth0()
  return (
    <div 
      style={{
        display: 'flex',
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '100vh', 
        flexDirection: 'column' ,
      }}
    >
      <div style={{ padding: '20px', textAlign: 'center', backgroundColor: 'white' }}>
        <p style={{ backgroundColor: '#23344f', color: 'white', padding: '20px', width: '100%', textAlign: 'center' }}>Forbidden (403)</p>
        <p style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#23344f' }}>
          You do not have access to this page.
        </p>
        <p style={{ fontSize: '1rem' }}>
          If you think this is an error, contact the administrator.
        </p>
        <Button variant="primary" onClick={() => logout()}>Sign In Again</Button>
      </div>
    </div>
  );
};

export default ForbiddenPage;